module.exports = __webpack_public_path__ + "static/media/progress-chart.d67a1a54.svg";